import { i18n } from '@lingui/core';
import _ from 'lodash';
import { Box } from '@material-ui/core';
import { t, Trans } from '@lingui/macro';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { makeStyles } from '@material-ui/core/styles';
import { RowFlexLayout } from '../../layout';
import FormSection from '../../form/FormSection';
import LinkButton from '../../links/LinkButton';
import {
    AGENT_VOIP_MODE_FIELD,
    AGENT_VOIP_REGISTRATION_DETAIL_REGISTRATION_STATUS,
    VOIP_MODE_NONE,
    AGENT_VOIP_REGISTRATION_DETAIL_HAS_INFO,
    AGENT_VOIP_REGISTRATION_DETAIL_HAS_REGISTRATION_STATUS,
    AGENT_VOIP_REGISTRATION_DETAIL_IS_REGISTERED,
    AGENT_VOIP_REGISTRATION_DETAIL_NO_REGISTRATION_MESSAGE,
    AGENT_VOIP_REGISTRATION_DETAIL_LAST_REGISTERED,
    AGENT_VOIP_CONFIGURATION_ADAPTER_TYPE_FIELD,
} from '../agents-voip/AgentVoIPConstants';
import { ADAPTER_TYPE_WIRELESS } from './AgentConstants';

export const useStyles = makeStyles((theme) => ({
    failure: {
        '& svg': {
            marginRight: theme.spacing(2),
            color: theme.palette.status.red,
        },
    },
    success: {
        '& svg': {
            marginRight: theme.spacing(2),
            color: theme.palette.status.green,
        },
    },
    registrationInfo: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
}));

const adapterWiredText = i18n._(t`Wired Interface`);
const adapterWirelessText = i18n._(t`Wireless Interface`);

function buildAdapterType(latestAgentData, agentHasWireless) {
    if (agentHasWireless) {
        if (_.get(latestAgentData, AGENT_VOIP_CONFIGURATION_ADAPTER_TYPE_FIELD) === ADAPTER_TYPE_WIRELESS) {
            return adapterWirelessText;
        }
    }

    return adapterWiredText;
}

function buildRegistrationString(latestAgentData, adapterType) {
    const status = _.get(latestAgentData, AGENT_VOIP_REGISTRATION_DETAIL_REGISTRATION_STATUS);
    const lastRegistered = _.get(latestAgentData, AGENT_VOIP_REGISTRATION_DETAIL_LAST_REGISTERED);
    return `${status} (${adapterType}) - ${lastRegistered}`;
}

const voipNotConfiguredText = i18n._(t`nPoint not configured for VoIP`);
const registrationIconStyles = { fontSize: 32 };

export function AgentDetailVoIP({ latestAgentData, agentHasWireless }) {
    const classes = useStyles();
    const voipConfigLocation = `/admin/voip/${latestAgentData._id}`;
    const voipMode = _.get(latestAgentData, AGENT_VOIP_MODE_FIELD);
    const adapterType = buildAdapterType(latestAgentData, agentHasWireless);
    const registrationString = buildRegistrationString(latestAgentData, adapterType);
    const isRegistered = _.get(latestAgentData, AGENT_VOIP_REGISTRATION_DETAIL_IS_REGISTERED);
    const registrationIcon = isRegistered ? (
        <CheckCircleIcon style={registrationIconStyles} />
    ) : (
        <ErrorIcon style={registrationIconStyles} />
    );
    const registrationIconClass = isRegistered ? classes.success : classes.failure;

    return (
        <>
            <FormSection title={<Trans>VoIP Configuration</Trans>}>
                <Box mt={3}>
                    {voipMode === VOIP_MODE_NONE && <Typography variant="body2">{voipNotConfiguredText}</Typography>}

                    {_.get(latestAgentData, AGENT_VOIP_REGISTRATION_DETAIL_HAS_INFO) && (
                        <>
                            {!_.get(latestAgentData, AGENT_VOIP_REGISTRATION_DETAIL_HAS_REGISTRATION_STATUS) && (
                                <Typography variant="body2">
                                    {_.get(latestAgentData, AGENT_VOIP_REGISTRATION_DETAIL_NO_REGISTRATION_MESSAGE)}
                                </Typography>
                            )}

                            {_.get(latestAgentData, AGENT_VOIP_REGISTRATION_DETAIL_HAS_REGISTRATION_STATUS) && (
                                <RowFlexLayout vCenter>
                                    <div className={registrationIconClass}>{registrationIcon}</div>
                                    <div className={classes.registrationInfo}>{registrationString}</div>
                                </RowFlexLayout>
                            )}
                        </>
                    )}
                    <Box mt={3}>
                        <LinkButton label={<Trans>VoIP Configuration</Trans>} url={voipConfigLocation} newTab />
                    </Box>
                </Box>
            </FormSection>
        </>
    );
}
